import React from 'react';

const rows = [
  { k: 'Pricing model', c: 'CPM / CPC', a: 'CPM / CPC', t: 'CPM', r: 'CPA / CPS only' },
  { k: 'Pay per verified sale', c: false, a: false, t: false, r: true },
  { k: 'Zero-risk spend model', c: false, a: false, t: false, r: true },
  { k: 'No minimum budget', c: false, a: false, t: false, r: true },
  { k: 'Fully managed service', c: false, a: 'Partial', t: false, r: true },
  { k: 'Dynamic creative included', c: 'Extra cost', a: 'Limited', t: false, r: '✓ Included' },
  { k: 'Buyer intent AI modeling', c: 'Basic', a: 'Basic', t: 'Basic', r: '✓ 100+ variables' },
  { k: 'Live in 48 hours', c: false, a: false, t: false, r: '✓ Guaranteed' },
];

function Cell({ v, accent }) {
  if (v === true) return <span className={`${accent ? 'text-[#ff5117]' : 'text-[#22d07a]'} font-bold`}>✓</span>;
  if (v === false) return <span className="text-[#f0f0f0]">✗</span>;
  return <span className={accent ? 'text-[#ff5117] font-semibold' : 'text-[#c9c9c9]'}>{v}</span>;
}

export default function CpmVsCpsSection() {
  return (
    <section className="py-12 lg:py-16 bg-[#262626] relative overflow-hidden" id="cpa-vs-cpm" data-testid="cpm-cps-section">
       <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <div className="highlights-kicker text-white">
          <span />WHY CPM IS NEGLIGENCE
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em]">
            You Pay For Clicks. We Pay For <span className="accent">Sales.</span>
          </h2>
          <div className="lg:col-span-5">
            <p className="reveal-on-scroll leading-relaxed sec-subhead text-white">
              Legacy retargeting platforms charge when attention happens. Retarget360.ai charges when revenue happens, aligning every campaign with verified business outcomes.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 border border-[#5a5a5a] mt-8">
          <div className="p-6 lg:p-8 border-b lg:border-b-0 lg:border-r border-[#5a5a5a] bg-black/30">
            <div className="mono-label mb-2">CRITEO / ADROLL / TRADE DESK</div>
            <div className="font-display text-[40px] md:text-[48px] font-black">CPM / CPC</div>
            <p className="text-[16px] text-[#f0f0f0] leading-relaxed">
              You pay per 1,000 impressions or per click — regardless of whether a single sale is made. Budget depletes continuously. ROAS is never guaranteed. Risk is entirely yours.
            </p>
          </div>
          <div className="p-6 lg:p-8 bg-[#0b0b0b]">
            <div className="mono-label text-[#ff5117] mb-2">RETARGET360.AI</div>
            <div className="font-display text-[40px] md:text-[48px] font-black accent">CPA / CPS</div>
            <p className="text-[16px] text-[#f0f0f0] leading-relaxed">
              You pay <span className="font-bold">only when a verified sale occurs.</span> Not for impressions. Not for clicks. Every dollar is tied to a confirmed revenue event.
            </p>
          </div>
        </div>

        <div className="cpm-cps-table-scroll border border-[#5a5a5a] mt-8 lg:mt-12">
          <table className="w-full text-left min-w-[720px]">
            <thead>
              <tr className="border-b border-[#5a5a5a] bg-[#0b0b0b]">
                <th className="text-[15px] p-3 lg:p-5 text-left font-bold">CAPABILITY</th>
                <th className="text-[15px] p-3 lg:p-5 font-bold">CRITEO</th>
                <th className="text-[15px] p-3 lg:p-5 font-bold">ADROLL</th>
                <th className="text-[15px] p-3 lg:p-5 font-bold">TRADE DESK</th>
                <th className="text-[15px] p-3 lg:p-5 text-[#00e0ff] font-bold">RETARGET360.AI</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-[#5a5a5a] last:border-0 hover:bg-[#0b0b0b] transition-colors">
                  <td className="p-3 lg:p-5 text-[14px] font-bold">{r.k}</td>
                  <td className="p-3 lg:p-5 text-[14px] font-bold"><Cell v={r.c} /></td>
                  <td className="p-3 lg:p-5 text-[14px] font-bold"><Cell v={r.a} /></td>
                  <td className="p-3 lg:p-5 text-[14px] font-bold"><Cell v={r.t} /></td>
                  <td className="p-3 lg:p-5 text-[14px] font-bold text-[#00e0ff]"><Cell v={r.r} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
